import React from "react";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";

const ExamType = ({ examType, handleExamTypeChange }) => {
  return (
    <div>
      <FormControl fullWidth size="small">
        <InputLabel id="demo-simple-select-label">Exam Type</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={examType}
          label="Exam Type"
          onChange={handleExamTypeChange}
        >
          <MenuItem value="Subjective">Subjective</MenuItem>
          <MenuItem value="Objective">Objective</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default ExamType;
